import React from 'react';
import HomePage from './Pages/HomePage';
import ErrorPage from './Pages/ErrorPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './styles.css';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
};

export default App;
